import React, { useEffect, useState } from "react";
import { Link, redirect, useNavigate, useSearchParams } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  FacebookAuthProvider,
  fetchSignInMethodsForEmail,
  linkWithCredential,
  sendEmailVerification,
  signInWithEmailAndPassword,
  signInWithPopup,
  updateProfile,
} from "firebase/auth";
import {
  setDoc,
  doc,
  serverTimestamp,
  getFirestore,
  getDoc,
} from "firebase/firestore";
import { auth, db, facebookProvider, googleProvider } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import { toastOptions } from "../lib/toastOptions";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import useUserCountry from "../StatesStore/UserCountry";
import { generateReferralCode } from "../lib/generateReferralCode";
import { handleInvite } from "../Referral/HandleInvite";
import useUserStore from "../StatesStore/UserStore";
import { WelcomeUser } from "../EmailSystem/sendEmails";
import useUrlState from "../StatesStore/CurrentURL";
import usePointsStore from "../StatesStore/PointsTable";
import { storeReferralCode } from "../lib/storeReferralCode";
import { getAllStoredReferralCodes } from "../lib/storedReferralCode";
import IncrementInviteClicks from "../Referral/IncrementInviteClicks";
const Signup_Landing = ({ isSmallScreen }) => {
  const { user } = UserAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState({
    name: "",
    email: "",
    pass: "",
    confirmPass: "",
  });
  const step6 =
    process.env.PUBLIC_URL + "/assets/landing/webImages/step6/step6.png";
  const step6BGImg =
    process.env.PUBLIC_URL + "/assets/landing/webImages/step6/bg-img.png";

  const step6BGImgMobile =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step1/bg-img.png";
  const step6Mobile =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step6/step6.png";

  const googleLogoPath =
    process.env.PUBLIC_URL + "/assets/images/logo/google-logo.svg";
  const facebookLogoPath =
    process.env.PUBLIC_URL + "/assets/images/logo/facebook-logo.svg";

  const navigate = useNavigate();
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const country = useUserCountry((state) => state.country);
  const { setUser, createId } = useUserStore(); //for storing user
  const pointsTable = usePointsStore((state) => state.pointsTable);
  const url = useUrlState((state) => state.url);
  const redirectUser = useNavigate();
  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get("ref");
  googleProvider.addScope("email");
  facebookProvider.addScope("email");
  const handleSubmission = async (e) => {
    e.preventDefault();
    const countryCode = "";
    const phoneNumber = "";
    const terms = false;
    //setting submit button disable to avoid user firing repeatitive events
    const regex = /^[a-zA-Z\s]*$/;
    // Validate if the fields are not empty
    if (!regex.test(name)) {
      setError((prevState) => ({
        ...prevState,
        name: "Name can only contain alphabets",
      }));
      return;
    }
    if (pass.length < 6) {
      setError((prevState) => ({
        ...prevState,
        pass: "Password must be at least 6 characters",
      }));
      return;
    }

    setSubmitButtonDisabled(true);
    // Uppercase the first letter of each word
    const NAME = name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
    // Split full name into firstName and lastName
    const [firstName, ...lastNameArray] = NAME.split(" ");
    const lastName = lastNameArray.join(" ");

    // Convert the photo to base64

    try {
      const authUser = await createUserWithEmailAndPassword(auth, email, pass);
      console.log("authuser", authUser);
      //createUser(email,pass)
      // Set displayName using updateProfile
      await updateProfile(authUser.user, {
        displayName: NAME,
      });
      // Concatenate country code and phone number
      const fullPhoneNumber = `${countryCode}${phoneNumber}`;
      const userDocRef = doc(db, "users", authUser.user.uid);

      // Generate random numbers for followers, following, and postCount
      const followers = 0;
      const following = 0;
      const postCount = 0;
      const connectionCount = 0;
      const referralCode = generateReferralCode();
      try {
        // Use setDoc to create or update the document
        await setDoc(userDocRef, {
          email,
          userName: NAME,
          firstName,
          lastName,
          birthday: null,
          phoneNumber: fullPhoneNumber,
          overview: null,
          products: null,
          photo: null, // Set to null if photoBase64 is undefined
          userTitle: null,
          timestamp: serverTimestamp(),
          region: country || null,
          followers,
          following,
          postCount,
          connectionCount,
          underAge: null,
          parentalConsent: null,
          favCategories: [],
          gender: null,
          location: "",
          terms: terms, //adding this to users object in firestore
          heardAboutUs: "",
          referralCode: referralCode,
          isVerified: false,
        });
      } catch (error) {
        console.error(error, " SetDoc");
      }
      const newUser = {
        userName: NAME,
        email,
        firstName,
        lastName,
        birthday: null,
        phoneNumber: fullPhoneNumber,
        overview: null,
        products: null,
        photo: null, // Set to null if photoBase64 is undefined
        userTitle: null,
        timestamp: serverTimestamp(),
        region: country || null,
        followers,
        following,
        postCount,
        connectionCount,
        underAge: null,
        parentalConsent: null,
        favCategories: [],
        gender: null,
        location: "",
        terms: terms, //adding this to users object in firestore
        heardAboutUs: "",
        referralCode: referralCode,
        isVerified: false,
      };
      console.log("newUser", newUser);
      await setUser(newUser);
      createId(authUser.user.uid);
      // After sign-up, search for the user with the referral code and add invite
      handleInvite(inviteCode, authUser, email, pointsTable);
      console.log("Data", authUser.user);
      toast.success(
        "Check you inbox for email verification link",
        toastOptions
      );
      await sendEmailVerification(authUser.user)
        .then(() => {
          // Email verification sent!
          console.log("Email verification sent!");
          navigate("/VerifyEmail");
        })
        .catch((error) => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error(
            "Error sending email verification:",
            errorCode,
            errorMessage
          );
        });
    } catch (err) {
      setSubmitButtonDisabled(false);
      console.error("Sign up error:", err);
      if (err.code === "auth/email-already-in-use") {
        setError((prevState) => ({
          ...prevState,
          email: "Email already exists",
        }));
      } else {
        console.error(err);
      }
      toast.error("Sign up failed. Please try again.", toastOptions);
    }
  };

  const googleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      console.log("result", result);
      return result;
    } catch (error) {
      throw error;
    }
  };
  const facebookSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      console.log(result.user);
      return result;
    } catch (error) {
      if (error.code === "auth/account-exists-with-different-credential") {
        const pendingCred = FacebookAuthProvider.credentialFromError(error);
        const email = error.customData.email;
        const signInMethods = await fetchSignInMethodsForEmail(auth, email);
        console.log(signInMethods);
        if (signInMethods.includes("google.com")) {
          try {
            alert(
              "Account with this email " +
                email +
                " already exists. You need to login with gmail first in order to link both accounts"
            );
            const userCredential = await signInWithPopup(auth, googleProvider);
            await linkWithCredential(userCredential.user, pendingCred);
            console.log("Successfully linked existing account with Facebook");
          } catch (linkError) {
            console.error("Error linking credential:", linkError);
          }
        } else if (signInMethods.includes("password")) {
          try {
            const password = prompt(
              "Account with this email " +
                email +
                " already existed. Enter you password in order to link both accounts:"
            );
            const userCredential = await signInWithEmailAndPassword(
              auth,
              email,
              password
            ); // No password needed
            await linkWithCredential(userCredential.user, pendingCred);
            console.log("Successfully linked existing account with Facebook");
          } catch (linkError) {
            console.error("Error linking credential:", linkError);
          }
        } else {
          console.log("Other sign-in methods detected:", signInMethods);
          // Handle other provider linking if needed
        }
      } else {
        console.error("Error during sign-in:", error);
      }
    }
  };
  const handleGoogleSignIn = async () => {
    try {
      const result = await googleSignIn();
      // Check if the result is defined and has a 'user' property
      if (result && result.user) {
        // Extract user information from the Google sign-in result
        const { user } = result;
        if (user) {
          console.log("user google", user);
          // console.log(user.emailVerified);
          user.emailVerified = true;
          user.email = user.providerData[0].email;
          // console.log("BEFORE CREATING ID");
          createId(user.uid);
          if (!user.displayName) {
            const displayName = "DefaultDisplayName";
            await updateProfile(user, { displayName });
          }

          // Store user information in Firestore
          const db = getFirestore();
          const userRef = doc(db, "users", user.uid);

          // Check if the user already exists in Firestore
          const docSnap = await getDoc(userRef);
          console.log("here ser google", user);
          //new user
          if (!docSnap.exists()) {
            await WelcomeUser(user.displayName, user.providerData[0]?.email);
            console.log("BEFORE SETING IT TRUE");
            auth.currentUser.emailVerified = true;
            fetch(process.env.REACT_APP_API + "/api/updateEmailVerified", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ uid: user.uid }),
            });
            const referralCode = generateReferralCode();
            const displayNameParts = (
              user.displayName || "DefaultDisplayName"
            ).split(" ");
            //make user dictionary
            const newUser = {
              userName: user.displayName || "DefaultDisplayName",
              email: user.email,
              firstName: displayNameParts[0] || null,
              lastName: displayNameParts.slice(1).join(" ") || null,
              birthday: user.birthday || null,
              phoneNumber: user.phoneNumber || null,
              gender: user.gender || null,
              photo: user.photoURL || null,
              overview: user.overview || null,
              products: user.products || null,
              timestamp: serverTimestamp(),
              location: null,
              userTitle: null,
              terms: false, //adding this to users object in firestore
              heardAboutUs: "",
              referralCode: referralCode,
              isVerified: true,
            };
            handleInvite(inviteCode, user.uid, user.email, pointsTable);
            //save the state of user
            await setUser(newUser);
            //set document in firestore here
            await setDoc(userRef, newUser);
            //user has no gender or birthday
            try {
              toast.success("Sign in with google successfull!", toastOptions);
              //redirect to more questions
              redirectUser("/SignInInput");
            } catch (error) {
              console.log("Error Signing in");
              toast.error("Sign up failed. Please try again.", toastOptions);
              redirect("/SignIn");
            }
          } else {
            console.log("GOING BACK TO OLD URL BYEEE!!");
            if (user.gender === null || user.birthday === null)
              redirectUser("/SignInInput");
            redirectUser(url);
          }
        }
      }
    } catch (error) {
      console.error("Error during Google sign-in:", error);
      if (error.code === "auth/popup-closed-by-user") {
        // alert("Google Sign-In popup closed. Please try again.");
        redirectUser("/SignIn");
      } else if (error.code === "auth/cancelled-popup-request") {
        console.error(error);
        // alert("Google Sign-In request cancelled. Please try again.");
      } else {
        console.error(error);
        // alert("Google Sign-In failed. Please try again.");
      }
    }
  };

  const handleFacebookSignIn = async () => {
    try {
      const result = await facebookSignIn();
      console.log(result);
      // Check if the result is defined and has a 'user' property
      if (result && result.user) {
        // Extract user information from the Google sign-in result
        const { user } = result;
        if (user) {
          console.log("user facebook", user);
          createId(user.uid);
          if (!user.displayName) {
            const displayName = "DefaultDisplayName";
            await updateProfile(user, { displayName });
          }

          // Store user information in Firestore
          const db = getFirestore();
          const userRef = doc(db, "users", user.uid);

          // Check if the user already exists in Firestore
          const docSnap = await getDoc(userRef);
          console.log("here ser facebook", user);
          //new user
          if (!docSnap.exists()) {
            await WelcomeUser(user.displayName, user.providerData[0]?.email);
            fetch(
              "https://us-central1-duplookflock-beada.cloudfunctions.net/api/api/updateEmailVerified",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ uid: user.uid }),
              }
            );
            auth.currentUser.emailVerified = true;
            const referralCode = generateReferralCode();
            const displayNameParts = (
              user.displayName || "DefaultDisplayName"
            ).split(" ");
            //make user dictionary
            const newUser = {
              userName: user.displayName || "DefaultDisplayName",
              email: user.email,
              firstName: displayNameParts[0] || null,
              lastName: displayNameParts.slice(1).join(" ") || null,
              birthday: user.birthday || null,
              phoneNumber: user.phoneNumber || null,
              gender: user.gender || null,
              photo: user.photoURL || null,
              overview: user.overview || null,
              products: user.products || null,
              timestamp: serverTimestamp(),
              location: null,
              userTitle: null,
              terms: false, //adding this to users object in firestore
              heardAboutUs: "",
              referralCode: referralCode,
              isVerified: true,
            };
            handleInvite(inviteCode, user.uid, user.email, pointsTable);
            //user has no gender or birthday
            //save the state of user
            await setUser(newUser);
            //set document in firestore here
            await setDoc(userRef, newUser);
            //redirect to gender/birthday compoennt
            try {
              toast.success("Sign in with Facebook successfull!", toastOptions);
              //redirect to more questions
              redirectUser("/SignInInput");
            } catch (error) {
              console.log("Error Signing in");
              toast.error("Sign up failed. Please try again.", toastOptions);
              redirect("/SignIn");
            }
          } else {
            redirectUser(url);
          }
        }
      }
    } catch (error) {
      console.error("Error during Facebook sign-in:", error);
      if (error.code === "auth/popup-closed-by-user") {
        // alert("Facebook Sign-In popup closed. Please try again.");
        redirectUser("/login");
      } else if (error.code === "auth/cancelled-popup-request") {
        console.error(error);
        // alert("Facebook Sign-In request cancelled. Please try again.");
      } else {
        console.error(error);
        // alert("Facebook Sign-In failed. Please try again.");
      }
    }
  };

  useEffect(() => {
    if (inviteCode) {
      console.log("inviteCode", inviteCode);

      storeReferralCode(inviteCode);
      IncrementInviteClicks(inviteCode);
    }
    const referralCodes = getAllStoredReferralCodes();
    console.log("Referral Codes to be sent:", referralCodes);
  }, []);
  return (
    <>
      <style jsx>
        {`
          .hoverBtn:hover {
            background-color: rgb(0, 0, 0, 0.1);
          }
        `}
      </style>
      {isSmallScreen ? (
        <>
          {/* <div>
        <img src={step6Mobile} alt="" />
      </div> */}
          <div
            className="d-flex align-items-center flex-column justify-content-center"
            style={{
              height: "100vh",
              backgroundImage: `url(${step6BGImgMobile})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              padding: "0rem 2rem",
            }}
          >
            <div
              className="d-flex flex-column justify-content-center text-center gap-2 px-4"
              style={{
                width: "100%",
                height: "30%",
              }}
            >
              <div
                style={{
                  color: "white",
                  fontSize: "2.5rem",
                  lineHeight: "3rem",
                  fontFamily: "Playfair Display",
                  fontWeight: 500,
                }}
              >
                <div
                  className="mb-2 d-inline-flex justify-content-center"
                  style={{ position: "relative" }}
                >
                  <svg
                    style={{
                      position: "absolute",
                      height: "5rem",
                      top: "-0.5rem",
                    }}
                    width="172"
                    height="72"
                    viewBox="0 0 172 72"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.5">
                      <path
                        d="M162.915 35.9814C162.915 39.0566 160.894 42.0808 157.013 44.9122C153.144 47.7358 147.512 50.2995 140.507 52.4611C126.505 56.7825 107.13 59.4629 85.7074 59.4629C64.2848 59.4629 44.91 56.7825 30.9074 52.4611C23.9031 50.2995 18.2712 47.7358 14.4013 44.9122C10.5208 42.0808 8.5 39.0566 8.5 35.9814C8.5 32.9062 10.5208 29.8821 14.4013 27.0507C18.2712 24.2271 23.9031 21.6634 30.9074 19.5018C44.91 15.1804 64.2848 12.5 85.7074 12.5C107.13 12.5 126.505 15.1804 140.507 19.5018C147.512 21.6634 153.144 24.2271 157.013 27.0507C160.894 29.8821 162.915 32.9062 162.915 35.9814Z"
                        stroke="#E87C00"
                      />
                      <path
                        d="M171.469 53.8056C171.393 55.0017 170.792 56.1062 169.633 57.1065C168.47 58.1091 166.771 58.9844 164.565 59.7165C160.156 61.1802 153.821 62.0398 146.004 62.2663C130.378 62.7192 108.938 60.6404 85.3915 55.9148C61.8451 51.1892 40.6816 44.7175 25.5029 38.0823C17.9096 34.763 11.8406 31.4141 7.7233 28.239C5.6643 26.6512 4.11618 25.124 3.10777 23.6857C2.10174 22.2508 1.65345 20.9358 1.7289 19.7396C1.80435 18.5435 2.40524 17.439 3.56487 16.4387C4.72725 15.4361 6.4269 14.5607 8.63223 13.8287C13.0421 12.365 19.3766 11.5054 27.1935 11.2789C42.8193 10.826 64.2599 12.9047 87.8062 17.6304C111.353 22.356 132.516 28.8277 147.695 35.4629C155.288 38.7822 161.357 42.131 165.474 45.3062C167.533 46.894 169.082 48.4211 170.09 49.8595C171.096 51.2944 171.544 52.6094 171.469 53.8056Z"
                        stroke="#E87C00"
                      />
                    </g>
                  </svg>
                  Sign up
                </div>{" "}
                to get Inspired
              </div>
              <p
                className="px-4 m-0"
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "1.1rem",
                  color: "white",
                }}
              >
                Find new fashion and ideas to try on.
              </p>
            </div>
            <div
              style={{
                width: "100%",
                height: "40%",
              }}
            >
              <div className="d-flex flex-column gap-2">
                <div>
                  <Link to={"/SignUp"}>
                    <button
                      className="btn rounded-3 mt-1 py-2"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                        fontSize: "1.1rem",
                        width: "100%",
                        backgroundColor: "#1C6751",
                        color: "white",
                      }}
                    >
                      Continue with email
                    </button>
                  </Link>
                </div>
                <div>
                  <button
                    type="submit"
                    className="border border-2 btn rounded-3 py-2 d-flex align-items-center justify-content-center gap-2 bg-white"
                    onClick={handleGoogleSignIn}
                    style={{
                      fontFamily: "Open Sans",
                      fontWeight: 600,
                      fontSize: "1.1rem",
                      width: "100%",
                    }}
                  >
                    <img
                      src={googleLogoPath}
                      className="mx-1"
                      alt="Google"
                      style={{
                        width: "23px",
                        height: "23px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                    <div>Continue with Google</div>
                  </button>
                </div>
                <div>
                  <button
                    type="submit"
                    className="border border-2 btn rounded-3 py-2 d-flex align-items-center justify-content-center gap-2 border border-white text-white"
                    onClick={handleFacebookSignIn}
                    style={{
                      fontFamily: "Open Sans",
                      fontWeight: 400,
                      fontSize: "1.1rem",
                      width: "100%",
                    }}
                  >
                    <img
                      src={facebookLogoPath}
                      className="mx-1"
                      alt="Google"
                      style={{
                        width: "23px",
                        height: "23px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                    <div>Continue with Facebook</div>
                  </button>
                </div>
              </div>
              <p
                className="text-center px-4 m-0 text-white mt-5"
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "1rem",
                }}
              >
                Already a member?{" "}
                <Link style={{ color: "white" }} to="/SignIn">
                  Log in
                </Link>
              </p>
              <p
                className="text-center px-4 m-0 text-white mt-4"
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "0.6rem",
                }}
              >
                By continuing, you agree to Lookflock's Terms of Service and
                acknowledge you've read our{" "}
                <Link
                  style={{ color: "white", textDecoration: "underline" }}
                  to="/staticPages/privacyPolicy"
                >
                  Privacy Policy
                </Link>
              </p>
            </div>
          </div>
        </>
      ) : (
        <div
          className="d-flex align-items-center"
          style={{
            height: "100vh",
            backgroundImage: `url(${step6BGImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container d-flex align-items-center w-100 ps-4">
            <div
              className="h-100 mt-5"
              style={{
                width: "50%",
              }}
            >
              <div className="h-100 d-flex align-items-center">
                <div
                  className="rounded-3"
                  style={{
                    // height: "42rem",
                    width: "78%",
                    backgroundColor: "white",
                    padding: "1rem 3rem",
                    marginLeft: "3rem",
                  }}
                >
                  <div
                    className="text-center mb-4"
                    style={{ lineHeight: "0.5rem" }}
                  >
                    <h3
                      style={{
                        fontFamily: "Playfair Display",
                        fontWeight: 600,
                        fontSize: "1.75rem",
                      }}
                    >
                      Welcome to Lookflock
                    </h3>
                    <p
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                        fontSize: "0.95rem",
                      }}
                    >
                      Find new fashion ideas to try
                    </p>
                  </div>
                  <div className="d-flex flex-column gap-2">
                    <form
                      onSubmit={(e) => handleSubmission(e)}
                      className="d-flex flex-column gap-2"
                    >
                      <div>
                        <label
                          htmlFor="nameInput"
                          style={{
                            fontFamily: "Open Sans",
                            fontWeight: 600,
                            fontSize: "0.8rem",
                          }}
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                            setError({ ...error, name: "" });
                          }}
                          id="nameInput"
                          className="form-control rounded-3"
                          placeholder="Full Name"
                          style={{
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                            fontSize: "1rem",
                            width: "100%",
                          }}
                          required
                        />
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.8rem",
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                          }}
                        >
                          {error.name}
                        </div>
                      </div>
                      <div>
                        <label
                          htmlFor="emailInput"
                          style={{
                            fontFamily: "Open Sans",
                            fontWeight: 600,
                            fontSize: "0.8rem",
                          }}
                        >
                          Email address
                        </label>
                        <input
                          type="email"
                          id="emailInput"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setError({ ...error, email: "" });
                          }}
                          className="form-control rounded-3"
                          placeholder="Email"
                          style={{
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                            fontSize: "1rem",
                            width: "100%",
                          }}
                          required
                        />
                      </div>
                      <div className="position-relative">
                        <label
                          htmlFor="passwordInput"
                          style={{
                            fontFamily: "Open Sans",
                            fontWeight: 600,
                            fontSize: "0.8rem",
                            marginBottom: "0rem",
                          }}
                        >
                          Password
                        </label>
                        <input
                          type={showPassword ? "text" : "password"}
                          value={pass}
                          onChange={(e) => {
                            setPass(e.target.value);
                            setError({ ...error, pass: "" });
                          }}
                          id="passwordInput"
                          className="form-control rounded-3"
                          placeholder="Create a password"
                          style={{
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                            fontSize: "1rem",
                            width: "100%",
                          }}
                          required
                        />
                        <button
                          type="button"
                          className="btn position-absolute end-0 translate-middle-y"
                          style={{ zIndex: 1, top: "2.75rem" }}
                          onClick={() =>
                            setShowPassword((prevState) => !prevState)
                          }
                        >
                          <i
                            className={`bi bi-${
                              showPassword ? "eye-slash-fill" : "eye-fill"
                            }`}
                            style={{ fontSize: "1rem" }}
                          ></i>
                        </button>
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.8rem",
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                          }}
                        >
                          {error.pass}
                        </div>
                      </div>
                      <div className="position-relative">
                        <label
                          htmlFor="confirmPasswordInput"
                          style={{
                            fontFamily: "Open Sans",
                            fontWeight: 600,
                            fontSize: "0.8rem",
                            marginBottom: "0rem",
                          }}
                        >
                          Confirm Password
                        </label>
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          value={confirmPass}
                          onChange={(e) => {
                            setConfirmPass(e.target.value);
                            setError({ ...error, confirmPass: "" });
                          }}
                          id="confirmPasswordInput"
                          className="form-control rounded-3"
                          placeholder="Confirm your password"
                          style={{
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                            fontSize: "1rem",
                            width: "100%",
                          }}
                          required
                        />
                        <button
                          type="button"
                          className="btn position-absolute end-0 translate-middle-y"
                          style={{ zIndex: 1, top: "2.75rem" }}
                          onClick={() =>
                            setShowConfirmPassword((prevState) => !prevState)
                          }
                          disabled={submitButtonDisabled}
                        >
                          <i
                            className={`bi bi-${
                              showConfirmPassword
                                ? "eye-slash-fill"
                                : "eye-fill"
                            }`}
                            style={{ fontSize: "1rem" }}
                          ></i>
                        </button>
                        <div
                          className="text-danger"
                          style={{
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                            fontSize: "0.8rem",
                          }}
                        >
                          {pass !== confirmPass &&
                            "Password and Confirm Password do not match."}
                        </div>
                      </div>
                      {/* <div className="position-relative">
              <label
                htmlFor="dateOfBirth"
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  fontSize: "0.8rem",
                }}
              >
                Date of Birth
              </label>
              <DatePicker
                id="dateOfBirth"
                className="form-control rounded-3"
                placeholder="dd/mm/yyyy"
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "1rem",
                  width: "100%",
                }}
              />
            </div> */}
                      <div>
                        <button
                          type="submit"
                          className="btn rounded-3 mt-1 py-2"
                          style={{
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                            fontSize: "1rem",
                            width: "100%",
                            backgroundColor: "#1C6751",
                            color: "white",
                          }}
                        >
                          Sign up
                        </button>
                      </div>
                    </form>

                    <div
                      className="text-center"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 600,
                        fontSize: "0.8rem",
                      }}
                    >
                      OR
                    </div>
                    <div className="d-flex justify-content-center align-items-center gap-3">
                      <button
                        type="submit"
                        className="btn pt-0"
                        onClick={handleGoogleSignIn}
                        style={{
                          fontFamily: "Open Sans",
                          fontWeight: 600,
                          fontSize: "1rem",
                        }}
                      >
                        <img
                          src={googleLogoPath}
                          alt="Google"
                          style={{
                            width: "30px",
                            height: "30px",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        />
                      </button>
                      <button
                        type="submit"
                        className="btn pt-0"
                        onClick={handleFacebookSignIn}
                        style={{
                          fontFamily: "Open Sans",
                          fontWeight: 600,
                          fontSize: "1rem",
                        }}
                      >
                        <img
                          src={facebookLogoPath}
                          alt="Google"
                          style={{
                            width: "30px",
                            height: "30px",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        />
                      </button>
                    </div>
                    <p
                      className="text-center px-4 m-0"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                        fontSize: "0.6rem",
                      }}
                    >
                      By continuing, you agree to Lookflock's Terms of Service
                      and acknowledge you've read our{" "}
                      <Link
                        style={{ color: "black", textDecoration: "underline" }}
                        to="/staticPages/privacyPolicy"
                      >
                        Privacy Policy
                      </Link>
                    </p>
                    <p
                      className="text-center px-4 m-0"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 600,
                        fontSize: "0.7rem",
                      }}
                    >
                      Already a member?{" "}
                      <Link
                        style={{ color: "black", textDecoration: "underline" }}
                        to="/SignIn"
                      >
                        Login
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="d-flex flex-column justify-content-center"
              style={{
                width: "50%",
                padding: "0rem 11.5rem 0rem 4.5rem",
              }}
            >
              <div
                style={{
                  color: "white",
                  fontSize: "3rem",
                  lineHeight: "3.5rem",
                  fontFamily: "Playfair Display",
                  fontWeight: 500,
                }}
              >
                <div
                  className="mb-2 d-inline-flex justify-content-center"
                  style={{ position: "relative" }}
                >
                  <svg
                    style={{
                      position: "absolute",
                      height: "9rem",
                      top: "-2.5rem",
                    }}
                    width="331"
                    height="210"
                    viewBox="0 0 331 210"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.5">
                      <path
                        d="M300.95 79.4658C302.249 86.0418 299.833 93.0935 294.213 100.247C288.594 107.399 279.811 114.597 268.507 121.428C245.902 135.088 213.31 147.22 176.09 154.567C138.87 161.914 104.112 163.076 78.0127 159.031C64.9607 157.007 54.1017 153.686 46.1866 149.205C38.2696 144.724 33.3559 139.119 32.0578 132.543C30.7598 125.967 33.1752 118.915 38.7955 111.762C44.4145 104.61 53.1969 97.4114 64.5012 90.5804C87.1061 76.9207 119.698 64.7884 156.918 57.4415C194.138 50.0946 228.896 48.9325 254.996 52.9784C268.048 55.0016 278.907 58.323 286.822 62.8034C294.739 67.2848 299.652 72.8897 300.95 79.4658Z"
                        stroke="white"
                      />
                      <path
                        d="M319.867 110.665C320.627 116.001 317.228 121.058 310.1 125.603C302.996 130.132 292.311 134.07 278.818 137.215C251.838 143.504 213.744 146.601 170.933 145.005C128.122 143.41 88.7345 137.424 59.6678 129.046C45.1306 124.856 33.2042 120.075 24.7279 114.965C16.2231 109.837 11.3408 104.472 10.5813 99.1355C9.82172 93.7996 13.2204 88.7425 20.3484 84.1976C27.4526 79.668 38.1381 75.7306 51.6311 72.5854C78.6101 66.2965 116.704 63.199 159.516 64.7948C202.327 66.3907 241.714 72.3765 270.781 80.7545C285.318 84.9447 297.244 89.725 305.721 94.8354C314.226 99.9629 319.108 105.329 319.867 110.665Z"
                        stroke="white"
                      />
                    </g>
                  </svg>
                  Sign up
                </div>{" "}
                to get Inspired
              </div>
              <p
                className=" mt-4 pe-2"
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "1.6em",
                  color: "white",
                }}
              >
                Find new fashion and ideas to try on.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Signup_Landing;
